import { asDemoLocale } from "./demoLocale";

export const emptyList = () => ({
  Items: [] as unknown[],
  TotalCount: 0,
  Page: 1,
  PageSize: 20,
});

export const createNamedStub =
  <T = any>(value: T = emptyList() as T) =>
  (..._args: any[]): Promise<T> =>
    Promise.resolve(asDemoLocale(value));

export const createServiceStub = (): any =>
  new Proxy(
    {},
    {
      get: (_target, prop) => {
        if (prop === "__esModule") return true;
        if (prop === "then") return undefined;
        return createNamedStub();
      },
    }
  );
